import awsConfig from 'config/aws.config'; // eslint-disable-line
import AWS, { Config, CognitoIdentityCredentials } from 'aws-sdk';
import {
  CognitoUserPool,
  CognitoUserAttribute,
  AuthenticationDetails,
  CognitoUser,
} from 'amazon-cognito-identity-js';

import {
    CognitoSyncManager, // eslint-disable-line
} from 'amazon-cognito-js';

import { Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work

Config.region = awsConfig.region;
AWS.config.region = awsConfig.region;
const userPool = new CognitoUserPool(awsConfig.pool);


Config.region = awsConfig.region;
Config.credentials = new CognitoIdentityCredentials({
  IdentityPoolId: awsConfig.IdentityPoolId,
});


/*
* Not so great file as we have callback. Not ideal. Keep this file free unless it is very critical
*/
export function authenticateUser(username, password, cb) {
  const authenticationDetails = new AuthenticationDetails({ email: username, Password: password });
  const userData = { Username: username, Pool: userPool };
  const cognitoUser = new CognitoUser(userData);
  cognitoUser.authenticateUser(authenticationDetails, {
    onSuccess: (result) => {
      const Logins = {};
      Logins[`cognito-idp.${awsConfig.region}.amazonaws.com/${awsConfig.pool.UserPoolId}`] = result.getIdToken().getJwtToken();
      AWS.config.credentials = new CognitoIdentityCredentials({
        IdentityPoolId: awsConfig.IdentityPoolId,
        Logins,
      });
        // Initialize the Cognito Sync client
      // AWS.config.credentials = new CognitoIdentityCredentials({
      //   IdentityPoolId: awsConfig.IdentityPoolId,
      // });
      AWS.config.credentials.get(() => {
        const syncClient = new AWS.CognitoSyncManager();

        syncClient.openOrCreateDataset('preferences', (err1, dataset) => {
          dataset.put('count', '3', (error1, record) => { // eslint-disable-line
            dataset.synchronize({
              onSuccess(dataa, newRecords) { // eslint-disable-line
                            // Your handler code here
              },
            });
          });
        });
      });

      cb(false, { session: JSON.parse(JSON.stringify(result)), user: cognitoUser });
    },
    onFailure: (err) => {
      cb(err, null);
    },
  });
  global.cognitoUser = cognitoUser;
}

export function RegisterUser(username, password, attributes, cb) {
  const attributeList = [];
  attributes.forEach((attribute) => {
    attributeList.push(new CognitoUserAttribute(attribute));
  });
  userPool.signUp(username, password, attributeList, null,
      (err) => {
        if (err) {
          cb(err, null);
        } else {
          authenticateUser(username, password, cb);
        }
      });
}


export function forgotPassword(username, cb) {
  const params = {
    ClientId: awsConfig.pool.ClientId, /* required */
    Username: username, /* required */
  };
  const CognitoIdentityServiceProvider = new AWS.CognitoIdentityServiceProvider();
  CognitoIdentityServiceProvider.forgotPassword(params, (err, data) => {
    if (err) cb(err, null); // an error occurred
    else cb(false, data);        // successful response
  });
}

export function setPasswordByCode(username, password, code, cb) {
  const params = {
    ClientId: awsConfig.pool.ClientId, /* required */
    ConfirmationCode: code, /* required */
    Password: password, /* required */
    Username: username, /* required */
  };
  const CognitoIdentityServiceProvider = new AWS.CognitoIdentityServiceProvider();

  CognitoIdentityServiceProvider.confirmForgotPassword(params, (err, data) => {
    if (err) cb(err, null); // an error occurred
    else cb(false, data);           // successful response
  });
}

export function resetPassword(currentPassword, newPassword, cb) {
  const user = userPool.getCurrentUser();

  if (user != null) {
    user.getSession((err, session) => {
      if (err) {
        cb(true);
        return;
      }
      user.changePassword(currentPassword, newPassword, (error, data) => {
        if (error) {
          cb(true);
          return;
        }
        cb(false, { session, data });
      });
    });
  } else {
    cb(true);
  }
}


export function isSessionValid(cb) {
  const adminSupport = window.sessionStorage.getItem('admin_support');

  const user = userPool.getCurrentUser();
  if (adminSupport) {
    const session = window.sessionStorage.getItem('session');
    const previousUser = window.sessionStorage.getItem('user');
    const attributes = window.sessionStorage.getItem('attributes');
    cb(false, session, previousUser, attributes);
  } else if (user != null) {
    user.getSession((err, session) => {
      if (err) {
        cb(true);
        return;
      }
      user.getUserAttributes((error, data) => {
        if (error) {
          const temp = Map();
          cb(false, { session, user, temp });
          return;
        }
        const attributes = Map(data.reduce((previous, current) => {
          const temp = previous;
          temp[current.Name] = current.Value;
          return temp;
        }, {}));
        cb(false, { session, user, attributes });
      });
    });
  } else {
    cb(true);
  }
}

export function updateUserAttributes(attributes, cb) {
  const user = userPool.getCurrentUser();
  if (user != null) {
    user.getSession((err) => {
      if (err) {
        cb(true);
        return;
      }
      const attributeList = [];
      attributes.forEach((attribute) => {
        attributeList.push(new CognitoUserAttribute(attribute));
      });

      user.updateAttributes(attributeList, (error, data) => {
        if (error) {
          cb(error);
          return;
        }
        cb(false, data);
      });
    });
  } else {
    cb(true);
  }
}


export function logoutUser(cb) {
  const user = userPool.getCurrentUser();

  if (user != null) {
    user.signOut();
  }
  cb(false, null);
}


function s4() {
  return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
}

function guid() {
  return `${s4() + s4()}-${s4()}-${s4()}-${
        s4()}-${s4()}${s4()}${s4()}`;
}


export function updateProfilePicture(profileId, file, cb) {
  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
    region: awsConfig.region,
  });


  const S3 = new AWS.S3({ params: { Bucket: 'myrbimages' } });
  const params = {
    Key: `${guid()}.jpg`,
    ContentType: file.type,
    Body: file,
    ACL: 'public-read',
    Metadata: { profileId },
  };
  S3.upload(params, (err, result) => {
    if (err) {
      return cb(true, err);
    }
    return cb(false, result);
  });
}


// TODO here we are handling cognitoSycn



// WEBPACK FOOTER //
// ./src/common/services/session.service/session.service.js